<template>
	<div style="margin-top: -1rem;">
		<div class="actDiv">
			<label style="margin-left:0.625rem ;">小区</label>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search allowClear>
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<label style="font-size: 0.8rem;">时间范围：</label>
			<a-range-picker   style="font-size: 0.6875rem;width: 15rem;"  format="YYYY-MM-DD" @change="onChangeDate" size="small" show-time>
			</a-range-picker>
			<a-button type="primary"  size="small" @click="doQuery()" style="margin: 0 0.625rem" >查询</a-button>
			<a-button type="primary"  size="small" :disabled ="list.length==0" @click="exportData" :loading="exportLoading">导出</a-button>
			<a-button v-if="checkWhAdmin()" type="primary"  size="small" style="margin: 0 0.625rem" @click="showConfigLimitView">设置阈值</a-button>
		</div>
		<vxe-table  align="center" :data="list"  border max-height="600"   ref="mTable"
						 highlight-hover-row :loading="loading"   size="mini" resizable>
			<vxe-table-column type="seq" width="50"></vxe-table-column>
			<vxe-table-column title="小区" field="NeighborName" width="auto"></vxe-table-column>
			<vxe-table-column title="房间号" field="customerNum" width="120" show-overflow="title"></vxe-table-column>
			<vxe-table-column title="立户号" field="APID"  width="100"></vxe-table-column>
			<vxe-table-column title="表地址" field="MeterAddr"></vxe-table-column>
			
			<vxe-table-column title="最新抄表时间" field="read_time" width="160"></vxe-table-column>
			<vxe-table-column title="上次抄表时间" field="last_read_time" width="160"></vxe-table-column>
			<vxe-table-column title="最新抄表读数" field="read_data"></vxe-table-column>
			<vxe-table-column title="上次抄表读数" field="last_read_data"></vxe-table-column>
			<vxe-table-column title="用水量" field="use_amount" sortable width="80"></vxe-table-column>
			<vxe-table-column title="异常说明" field="result_desc"></vxe-table-column>
			<vxe-table-column title="操作" field="meter_id" width="120">
				<template #default="{ row }">
					<a-button size="small"  type="link" @click="readOneMeter(row)">抄表</a-button>
					<a-popconfirm title="确定要删除该条记录?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="deleteContent(row)">
						<a-button size="small"  type="link">删除</a-button>
					</a-popconfirm>
				</template>
			</vxe-table-column>
		</vxe-table>
		<ConfigOverLimitView ref="configView"/>
	</div>
</template>

<script>
	import ConfigOverLimitView from '/src/components/ConfigOverLimitView.vue'
	export default {
		components:{
			ConfigOverLimitView,
		},
		data(){
			return {
				theNeighbor:undefined,
				loading:false,
				list:[],
				neighborList:[],
				dateStart:null,
				dateEnd:null,
				exportLoading:false,
			}
		},
		methods: {
			showConfigLimitView(){
				this.$refs.configView.showView();
			},
			deleteContent(row){
				let param = {theId:row.id};
				let url = this.Api.getLastUrl(this.Api.DELETE_OVER_DATA_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('删除成功');
						this.doQuery();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			readOneMeter(row){
				let url = this.Api.getLastUrl(this.Api.READ_METER_4_SINGLE_URL);
				let param = {meterId:row.meter_id};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success(msg);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			exportData(){
				this.exportLoading = true;
				let neighborId = null;
				if(this.theNeighbor !=null){
					neighborId = this.theNeighbor.key
				}
				let param = {
					neighborId:neighborId,
					beginDate:this.dateStart,
					endDate:this.dateEnd,
				};
				let url = this.Api.getLastUrl(this.Api.EXPORT_OVER_DATA_URL);
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '用量异常.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			onChangeDate(date, dateString) {
				this.dateStart=dateString[0];
				this.dateEnd=dateString[1];
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			doQuery(){
				let neighborId = null;
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_DATA_OVER_URL);
				if(this.theNeighbor !=null){
					neighborId = this.theNeighbor.key
				}
				let param = {
					neighborId:neighborId,
					beginDate:this.dateStart,
					endDate:this.dateEnd,
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list =result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			checkWhAdmin(){
				let wcId = this.Config.getUserLocal().wcId;
				let roleId = this.Config.getUserLocal().wcId;
				
				if(wcId == 37 && roleId == 2){
					return true;
				}else{
					return false;
				}
			},
		},
		created() {
			this.queryNeighbors();
			this.doQuery();
		},
	}
</script>

<style>
</style>
